module.exports = __webpack_public_path__ + "static/img/about_1000x420.f3ca8c41.jpg";